import api from "!/home/runner/work/boxel/boxel/node_modules/.pnpm/style-loader@2.0.0_patch_hash=579dd92e6adabd45669f9a99a01c6c28c97488c7bf4ee0d6c1c622a14592e4c8_webpack@5.104.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!/home/runner/work/boxel/boxel/node_modules/.pnpm/css-loader@5.2.7_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!/home/runner/work/boxel/boxel/node_modules/.pnpm/glimmer-scoped-css@0.8.1/node_modules/glimmer-scoped-css/dist/virtual-loader.js?filename=/home/runner/work/boxel/boxel/packages/host/node_modules/.embroider/rewritten-app/components/operator-mode/syntax-error-display.ts.CiAgLnN5bnRheC1lcnJvci1jb250YWluZXJbZGF0YS1zY29wZWRjc3MtMmY0ZGFmM2M2YS1mOTZkNDk1ZjVjXSB7CiAgICBiYWNrZ3JvdW5kOiB2YXIoLS1ib3hlbC0xMDApOwogICAgcGFkZGluZzogdmFyKC0tYm94ZWwtc3ApOwogICAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm94ZWwtcmFkaXVzKTsKICAgIGhlaWdodDogMTAwJTsKICB9Cg%3D%3D.glimmer-scoped.css!";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};